import { render, staticRenderFns } from "./NodeLink.vue?vue&type=template&id=2a3d489f"
import script from "./NodeLink.vue?vue&type=script&lang=ts"
export * from "./NodeLink.vue?vue&type=script&lang=ts"
import style0 from "./NodeLink.vue?vue&type=style&index=0&id=2a3d489f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports